import type { NewIngestionKeyResult } from '@jums-dashboard/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { callFunction } from '@/lib/callableClient';

import { ingestionSourcesQueryKey } from './useIngestionSources';

interface Payload {
  homeId: string;
  keyHash: string;
}

export default function useRegenerateIngestionKey() {
  const qc = useQueryClient();
  return useMutation<NewIngestionKeyResult, Error, Payload>({
    mutationFn: (payload) => callFunction<Payload, NewIngestionKeyResult>('regenerateIngestionKeyCallable', payload),
    onSuccess: (_data, vars) => {
      toast.success('Ingestion URL regenerated.');
      void qc.invalidateQueries({ queryKey: ingestionSourcesQueryKey(vars.homeId) });
    },
    onError: (err) => {
      toast.error(err.message || 'Failed to regenerate ingestion key.');
    },
  });
}
